/* MARQUE PARIS — buy box (offer tiers, scent slots, subscription, sticky bar) */
(function () {
  'use strict';

  function money(cents, format) {
    var n = (cents / 100);
    var str = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    str = str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*amount[^}]*\}\}/, str).replace(/<[^>]+>/g, '');
  }

  function init(root) {
    var scents = JSON.parse(root.getAttribute('data-scents') || '[]');
    var tiers = JSON.parse(root.getAttribute('data-tiers') || '[]');
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var subPct = parseInt(root.getAttribute('data-sub-pct') || '20', 10);
    var subCode = root.getAttribute('data-sub-code') || '';
    var after = root.getAttribute('data-after') || 'cart';
    var gifts = { 2: root.getAttribute('data-gifts-2') || '', 3: root.getAttribute('data-gifts-3') || '' };
    if (!scents.length || !tiers.length) return;

    var params = new URLSearchParams(window.location.search);
    var tier = parseInt(params.get('tier') || root.getAttribute('data-default-tier') || '3', 10);
    if (tier < 1 || tier > 3) tier = 3;

    var firstName = root.getAttribute('data-first-scent') || scents[0].name;
    var byVariant = params.get('variant');
    if (byVariant) {
      scents.forEach(function (s) { if (String(s.variant) === byVariant) firstName = s.name; });
    }
    var idx0 = Math.max(0, scents.findIndex(function (s) { return s.name === firstName; }));
    var pick = [idx0, (idx0 + 1) % scents.length, (idx0 + 3) % scents.length, (idx0 + 2) % scents.length, (idx0 + 4) % scents.length];
    var sub = root.querySelector('[data-mq-sub]');

    var el = {
      main: root.querySelector('[data-mq-main]'),
      thumbs: Array.prototype.slice.call(root.querySelectorAll('[data-mq-thumb]')),
      title: root.querySelector('[data-mq-title]'),
      tagline: root.querySelector('[data-mq-tagline]'),
      inspired: root.querySelector('[data-mq-inspired]'),
      selects: [1, 2, 3, 4, 5].map(function (j) { return root.querySelector('[data-mq-select="' + j + '"]'); }),
      jars: [1, 2, 3, 4, 5].map(function (j) { return root.querySelector('[data-mq-jar="' + j + '"]'); }),
      jarsBox: root.querySelector('[data-mq-jars]'),
      jarImgs: [1, 2, 3, 4, 5].map(function (j) { return root.querySelector('[data-mq-jar-img="' + j + '"]'); }),
      jarLabels: [1, 2, 3, 4, 5].map(function (j) { return root.querySelector('[data-mq-jar-label="' + j + '"]'); }),
      giftsLine: root.querySelector('[data-mq-gifts]'),
      subPrice: root.querySelector('[data-mq-sub-price]'),
      subSave: root.querySelector('[data-mq-sub-save]'),
      total: root.querySelector('[data-mq-total]'),
      compare: root.querySelector('[data-mq-compare]'),
      save: root.querySelector('[data-mq-save]'),
      atc: root.querySelector('[data-mq-atc]'),
      atcLabel: root.querySelector('[data-mq-atc-label]'),
      sticky: root.querySelector('[data-mq-sticky]'),
      stickyImg: root.querySelector('[data-mq-sticky-img]'),
      stickyScents: root.querySelector('[data-mq-sticky-scents]'),
      stickyTotal: root.querySelector('[data-mq-sticky-total]'),
      stickyCompare: root.querySelector('[data-mq-sticky-compare]'),
      stickyBtn: root.querySelector('[data-mq-sticky-btn]')
    };

    // Populate selects
    el.selects.forEach(function (sel, j) {
      if (!sel) return;
      sel.innerHTML = scents.map(function (s, i) {
        return '<option value="' + i + '">' + s.name + ' — inspired by ' + s.inspired + '</option>';
      }).join('');
      sel.value = String(pick[j]);
      sel.addEventListener('change', function () { pick[j] = parseInt(sel.value, 10); render(); });
    });

    // Tier prices (static)
    tiers.forEach(function (t) {
      var p = root.querySelector('[data-mq-tier-price="' + t.tier + '"]');
      var c = root.querySelector('[data-mq-tier-compare="' + t.tier + '"]');
      if (p) p.textContent = money(t.price, fmt);
      if (c) c.textContent = t.compare > t.price ? money(t.compare, fmt) : '';
    });

    root.querySelectorAll('input[name="mq-tier"]').forEach(function (r) {
      r.addEventListener('change', function () { tier = parseInt(r.value, 10); render(); });
    });
    if (sub) sub.addEventListener('change', render);

    // Gallery
    function setMain(src) {
      if (!el.main || !src) return;
      el.main.src = src;
      el.thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-src') === src); });
    }
    el.thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(t.getAttribute('data-src')); }); });

    function current() {
      return tiers.find(function (t) { return t.tier === tier; }) || tiers[0];
    }

    function totals() {
      var t = current();
      var useSub = sub && sub.checked;
      var price = t.price;
      if (useSub) price = t.plan ? t.planPrice : Math.round(t.price * (100 - subPct) / 100);
      return { t: t, price: price, compare: Math.max(t.compare, t.price), useSub: useSub };
    }

    function render() {
      var s1 = scents[pick[0]];
      root.querySelectorAll('[data-mq-tier]').forEach(function (l) {
        l.classList.toggle('is-selected', parseInt(l.getAttribute('data-mq-tier'), 10) === tier);
      });
      var slot = root.querySelector('[data-mq-tier-slot="' + tier + '"]');
      if (slot && el.jarsBox && el.jarsBox.parentNode !== slot) slot.appendChild(el.jarsBox);
      if (el.title) el.title.textContent = s1.name.toUpperCase();
      if (el.tagline) el.tagline.textContent = s1.line;
      if (el.inspired) el.inspired.textContent = s1.inspired;
      setMain(s1.img);

      var t0 = current();
      el.jars.forEach(function (jar, j) {
        if (!jar) return;
        jar.hidden = j >= t0.jars;
        if (el.jarImgs[j]) el.jarImgs[j].src = scents[pick[j]].pack || scents[pick[j]].img;
        if (el.jarLabels[j]) el.jarLabels[j].textContent = 'Jar ' + (j + 1) + (j >= t0.paid ? ' · free' : '');
      });
      if (el.giftsLine) el.giftsLine.textContent = gifts[tier] || '';

      var x = totals();
      var subPrice = x.t.plan ? x.t.planPrice : Math.round(x.t.price * (100 - subPct) / 100);
      if (el.subPrice) el.subPrice.textContent = money(subPrice, fmt);
      if (el.subSave) el.subSave.textContent = 'Save ' + money(x.t.price - subPrice, fmt);
      if (el.total) el.total.textContent = money(x.price, fmt);
      if (el.compare) el.compare.textContent = money(x.compare, fmt);
      if (el.save) el.save.textContent = 'you save ' + money(x.compare - x.price, fmt);
      var n = x.t.jars;
      if (el.atcLabel) el.atcLabel.textContent = (n > 1 ? 'Secure my jars' : 'Secure my jar') + ' · ' + money(x.price, fmt);

      if (el.stickyImg) el.stickyImg.src = s1.pack || s1.img;
      if (el.stickyScents) el.stickyScents.textContent = pick.slice(0, x.t.jars).map(function (i) { return scents[i].name; }).join(' · ');
      if (el.stickyTotal) el.stickyTotal.textContent = money(x.price, fmt);
      if (el.stickyCompare) el.stickyCompare.textContent = money(x.compare, fmt);
    }

    function add() {
      var x = totals();
      var props = {};
      var item = { quantity: 1 };
      if (tier === 1) {
        item.id = scents[pick[0]].variant;
      } else {
        item.id = x.t.variant;
        for (var j = 0; j < x.t.jars; j++) {
          props['Jar ' + (j + 1) + (j >= x.t.paid ? ' (free)' : '')] = scents[pick[j]].name + ' — inspired by ' + scents[pick[j]].inspired;
        }
        if (gifts[tier]) props['Gifts'] = gifts[tier].replace(/^Added at checkout:\s*/i, '');
      }
      if (x.useSub) {
        if (x.t.plan) item.selling_plan = x.t.plan;
        else props['Subscription'] = 'Every refill, ' + subPct + '% off';
      }
      if (Object.keys(props).length) item.properties = props;
      if (!item.id) { window.location.href = '/cart'; return; }

      el.atc.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          var dest = after === 'checkout' ? '/checkout' : '/cart';
          if (x.useSub && !x.t.plan && subCode) {
            window.location.href = '/discount/' + encodeURIComponent(subCode) + '?redirect=' + encodeURIComponent(dest);
          } else {
            window.location.href = dest;
          }
        })
        .catch(function () { el.atc.disabled = false; window.location.href = '/cart'; });
    }

    if (el.atc) el.atc.addEventListener('click', add);
    if (el.stickyBtn) el.stickyBtn.addEventListener('click', function () {
      el.atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    if (el.sticky && el.atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top < 0;
        el.sticky.classList.toggle('is-visible', !e.isIntersecting && below);
        el.sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(el.atc);
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-mq-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-mq-pdp]'); if (r) init(r); });
})();
